export const FIELD_TYPES = [
    'string',
    'text',
    'int',
    'decimal',
    'bool',
    'date',
    'time',
    'ref',
    'refMany',
    'enum',
    'dictItem',
    'dictItems',
    'json',
];
/** Людські назви типів полів (аркуш «Опис полів»). */
export const FIELD_TYPE_LABELS = {
    string: 'Текст',
    text: 'Довгий текст',
    int: 'Ціле число',
    decimal: 'Число',
    bool: 'Так / ні',
    date: 'Дата',
    time: 'Час (ГГ:ХХ)',
    ref: 'Код запису іншого довідника',
    refMany: 'Коди записів через кому',
    enum: 'Значення з переліку',
    dictItem: 'Код пункту класифікатора',
    dictItems: 'Коди пунктів класифікатора через кому',
    json: 'JSON',
};
/** Групи меню «Довідники» (SPEC розд. 4) у порядку показу. */
export const DIRECTORY_GROUPS = [
    'Структура',
    'Освіта',
    'Контингент',
    'Викладачі',
    'Ресурси',
    'Календар і час',
    'Навантаження',
    'Правила',
    'Класифікатори',
];
//# sourceMappingURL=types.js.map